export default __webpack_public_path__ + "static/media/mmarke_de_A4.83f3bf84.jpg";